/**
 * control cart version to display
 */

let cartWrapper = $('#orderNow'),
    carts = cartWrapper.children('div'),
    orderMobileArr = [0, 1],
    orderDesktopArr = [1, 0];

/**
 * Reorder of carts within #orderNow for TCR to work
 * 
 * @param {*} wrapper - cart component section
 * @param {*} items - children
 * @param {*} orderArr - order of appearance of the children 
 */
function cartsReorder(wrapper, items, orderArr) {
    for (let i = 0; i < orderArr.length; i++) {
        for (let j = 0; j < orderArr.length; j++) {
            if (i == orderArr[j]) {
                wrapper.append(items[j]);
                break;
            }
        }
    }
}

/**
 * Reorder carts (mobile and desktop) and change modifier class of cart section
 */
function displayCartSectionsDesktop() {    
    if ($('#orderNow').hasClass('cart--toggle')) {
        $('#orderNow').removeClass('cart--toggle').addClass('cart--sections');
        
        cartsReorder(cartWrapper, carts, orderDesktopArr);

        $('.cart-sections .cart__product.active').trigger("click");
    }
}

function displayCartToggleMobile() {                
    if ($('#orderNow').hasClass('cart--sections')) {
        $('#orderNow').removeClass('cart--sections').addClass('cart--toggle');
        
        cartsReorder(cartWrapper, carts, orderMobileArr);

        $('.cart-toggle .cart__product.active').trigger("click");
    }
}

/**
 * Load based on screen size or resize
 */
if (window.innerWidth > 1024) {
    displayCartSectionsDesktop();
    
} else {
    displayCartToggleMobile();
}

$(window).resize(function () {
    let cart = $('#orderNow');

    if (this.resizeWindow) {
        clearTimeout(this.resizeWindow);
    }

    this.resizeWindow = setTimeout(function () {
        if (window.innerWidth > 1024 && cart.hasClass('cart--toggle')) {
            displayCartSectionsDesktop();

        } else if (window.innerWidth <= 1024 && cart.hasClass('cart--sections')) {
            displayCartToggleMobile();
        }
    }, 500);
});
